import {
    Box,
    Button,
    Paper,
    TextField,
    Typography,
    useMediaQuery,
} from "@mui/material";
import {
    ChangeEvent,
    ChangeEventHandler,
    useEffect,
    useLayoutEffect,
    useState,
} from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useAuthStore } from "../../../store/auth.store";
import { Loading } from "../../../utils/components/Loading";
import { LoadingPage } from "../../../utils/components/LoadingPage";
import { enqueueSnackbar } from "notistack";

export function RegistrationLink() {
    const [searchParams, setSearchParams] = useSearchParams();
    const navigate = useNavigate();
    const hash = searchParams.get("hash");
    const {
        setUserBrowserData,
        accessToken,
        logout,
        refresh,
        registration,
        sendCode,
    } = useAuthStore();
    const isMobile = useMediaQuery("(max-width: 700px)");

    // Проверка авторизации и редирект на главную страницу, если авторизован
    const [loadingIsAuth, setLoadingIsAuth] = useState(false);
    useLayoutEffect(() => {
        (async () => {
            try {
                setLoadingIsAuth(true);
                if (accessToken) {
                    const isAuthed = await refresh();
                    console.log(isAuthed);
                    if (isAuthed) location.href = "/admin";
                }
            } catch (error) {
                logout();
            } finally {
                setLoadingIsAuth(false);
            }
        })();
    }, []);

    useEffect(() => {
        setUserBrowserData(navigator.userAgent);
    }, []);

    if (!hash)
        return (
            <Box
                sx={{
                    width: "100vw",
                    height: "100vh",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    gap: "30px",
                }}
            >
                <Paper
                    sx={{
                        padding: "40px",
                        margin: "0 40px",
                        display: "flex",
                        flexDirection: "column",
                        alignItems: "left",
                        gap: "8px",
                    }}
                >
                    <h1>Не найден уникальный код регистрации</h1>
                    <Button to={"/"} variant="contained" component={Link}>
                        На главную
                    </Button>
                </Paper>
            </Box>
        );

    const [loadingDataHash, setLoadingDataHash] = useState(false);
    const [email, setEmail] = useState("");
    useLayoutEffect(() => {
        (async () => {
            try {
                setLoadingDataHash(true);
                const email = await registration(hash);
                setEmail(email);
            } catch (error) {
            } finally {
                setLoadingDataHash(false);
            }
        })();
    }, []);

    const [code, setCode] = useState("");
    const [error, setError] = useState("");
    const handleChangeCode = (
        event: ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
    ) => {
        setCode(event.target.value.trim());
        if (event.target.value == "") setError("Введите специальный код");
        else setError("");
    };

    const handleSendCode = async () => {
        try {
            if (code == "") return setError("Введите специальный код");
            const response = await sendCode(code, hash);
            if (response) navigate("/registration/password");
            // else enqueueSnackbar({
            //     message:"Неверный специальный код",
            //     variant:"error"
            // })
        } catch (error) {}
    };

    if (loadingDataHash || loadingIsAuth) return <LoadingPage />;

    return (
        <Box
            sx={{
                width: "100vw",
                height: "100vh",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
            }}
        >
            <Paper
                sx={{
                    padding: "40px",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "flex-start",
                    gap: "10px",
                    margin: "0px 40px",
                }}
            >
                <h1>Проверьте адрес электронной почты</h1>
                <p>
                    Мы отправили вам специальный код на почту {email}. Введите
                    его в поле ниже для продолжения
                </p>
                <Box
                    sx={{
                        display: "flex",
                        width: "100%",
                        gap: "8px",
                        flexDirection: isMobile ? "column" : "row",
                    }}
                >
                    <TextField
                        error={error != ""}
                        id="outlined-error-helper-text"
                        label=""
                        placeholder="Введите код"
                        value={code}
                        onChange={handleChangeCode}
                        helperText={error}
                        sx={{
                            flex: "1",
                        }}
                    />
                    <Button
                        variant="contained"
                        sx={{
                            height: isMobile ? "auto" : "56px",
                        }}
                        onClick={handleSendCode}
                    >
                        Отправить
                    </Button>
                </Box>
                <Typography variant="caption" color="text.secondary">
                    Если вы не получили письмо, проверьте папку "Спам"
                </Typography>
                <Typography variant="caption" color="text.secondary">
                    Попали на эту страницу случайно?{" "}
                    <Link to="/">На главную</Link>
                </Typography>
            </Paper>
        </Box>
    );
}
